function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip-Transfers_Icon"
}, React.createElement("rect", {
  width: 25,
  height: 23
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Transfers_Icon",
  "data-name": "Transfers Icon",
  clipPath: "url(#clip-Transfers_Icon)"
}, React.createElement("rect", {
  width: 25,
  height: 23,
  fill: "#fff"
}), React.createElement("g", {
  id: "Group_2",
  "data-name": "Group 2",
  transform: "translate(1.742 1)"
}, React.createElement("path", {
  id: "Path_1",
  "data-name": "Path 7",
  d: "M429,179s-16.329,16.946-17.254,17.87,0-11.5,0-11.5",
  transform: "translate(-411.333 -179)",
  fill: "none",
  stroke: "#707070",
  strokeLinejoin: "round",
  strokeWidth: 2
}), React.createElement("path", {
  id: "Path_2",
  "data-name": "Path 8",
  d: "M17.664,0S1.335,16.946.411,17.87s0-11.5,0-11.5",
  transform: "translate(21.978 21) rotate(180)",
  fill: "none",
  stroke: "#707070",
  strokeLinejoin: "round",
  strokeWidth: 2
})));

var SvgTransfers = function SvgTransfers(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTransfers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/transfers.f275b062.svg";
export { ForwardRef as ReactComponent };